module.exports = __webpack_public_path__ + "static/about-us-splash.f5b5d76e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/about-us-splash.jpg
// module id = 870
// module chunks = 169928946856436